import { updatedObject } from '../../conf-utility/utility';
import * as actionCodes from '../action-type-codes';

export interface LOBDataState {
    selectedVehicle: object;
    selectedLOB: string | null,
    stepSelectionData: []
    opAppColumnName: string | null,
    vehicleData: object,
    selectedVCNumber: object,
    searchType: string | null,
    plDetails: object
}


const initialState: LOBDataState = {
    selectedVehicle: {},
    selectedLOB: null,
    stepSelectionData: [],
    opAppColumnName: null,
    vehicleData: {},
    selectedVCNumber: {
        ilmcv: null,
        hcv: null,
        scv: null,
        magic: null,
        winger: null,
        bus: null
    },
    searchType: null,
    plDetails: {}
}

export const lobDataReducer = (state = initialState, action: any): LOBDataState | undefined => {
    switch (action.type) {
        case actionCodes.LOBDATA_SAVE_SELECTED_VEHICLE: return updatedObject(state, { selectedVehicle: action.vehicleDetails, });
        case actionCodes.LOBDATA_SAVE_OP_APP_COLUMN_NAME: return updatedObject(state, { opAppColumnName: action.columnName, });
        case actionCodes.LOBDATA_SAVE_SELECTED_VALUE: return updatedObject(state, { vehicleData: { vehLxData: action.vehicleData_lx, vehCxData: action.vehicleData_cx } });
        case actionCodes.LOBDATA_SET_VC_NO: return updatedObject(state, { selectedVCNumber: { ...state.selectedVCNumber, [action.lobName]: action.value } })
        case actionCodes.LOBDATA_RESET_VC_NO: return updatedObject(state, { selectedVCNumber: { ...state.selectedVCNumber, [action.lobName]: null } })
        case actionCodes.RESET_ALL_STATE: return initialState
        case actionCodes.SAVE_SEARCH_TYPE: return updatedObject(state, {searchType: action.searchType})
        case actionCodes.LOBDATA_STATE_REINIT: return updatedObject(state, {...action.newStateData});
        case actionCodes.SAVE_VEHICLE_PL: return updatedObject(state, {plDetails: {pl: action.vehiclePlValue, lob: action.lob}})
        default: return state;
    }
}

export const getLOBDataState = (state: any) => state.lobDataState;
